import React from 'react';

const LegDocumentsLoaderRow = () => (
    <>
        <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip !py-0">
            <div className="px-3 flex items-center h-full">
                <div className="custom-loading w-4 h-4 rounded flex-none" />
            </div>
        </td>
        <td className="min-w-[210px] w-[210px] max-w-[210px]">
            <div className="flex gap-x-3 items-center">
                <div className="w-5 h-5 flex-none custom-loading rounded">lo</div>
                <p className="text-xs leading-[18px] font-medium text-grayLight900 flex-1 truncate custom-loading">lorem ipsum dolor sit amet</p>
            </div>
        </td>
        <td className="min-w-[140px] w-[140px] max-w-[140px]">
            <span className="custom-loading">Leg 1 (#WAL-ID-A)</span>
        </td>
        <td className="min-w-[155px] w-[155px] max-w-[155px]">
            <span className="custom-loading">Carrier BOL</span>
        </td>
        <td className="min-w-[160px] w-[160px] max-w-[160px]">
            <span className="custom-loading">Mon, Jan 27th, 2025</span>
        </td>
        <td className="min-w-[150px] w-[150px] max-w-[150px]">
            <div className="flex gap-x-2 items-center">
                <div className="w-5 h-5 rounded-full flex-none custom-loading">lo</div>
                <p className="text-xs leading-[18px] font-medium flex-1 truncate custom-loading">Olivia Rhye</p>
            </div>
        </td>
        <td className="min-w-[64px] w-[64px] max-w-[64px] sticky right-0 bg-inherit z-[1] table-cell-with-tooltip !py-0">
            <div className="flex items-center gap-1.5 justify-end h-full px-3">
                <div className="w-4 h-4 custom-loading rounded flex-none" />
                <div className="w-4 h-4 custom-loading rounded flex-none" />
            </div>
        </td>
    </>
);

export default LegDocumentsLoaderRow;
